<template>
  <div v-if="Object.keys(diadoc_info).length > 0" class="diadoc_info">
    <div class="diadoc_info__left">
      <div class="diadoc_info__left__wrap" ref="content">
        <div class="main_info" ref="main_info">
          <div class="line row">
            <div class="col-md-1 col-sm-1">
              <fg-input v-model="diadoc_info.id" type="text" :label="translate('diadoc_document.info.id')"
                        :placeholder="translate('diadoc_document.info.id')" :readonly="true"/>
            </div>

            <div class="col-md-1 col-sm-1">
              <fg-input v-model="diadoc_info.user_id" type="text" :label="translate('diadoc_document.info.user_id')"
                        :placeholder="translate('diadoc_document.info.user_id')" :readonly="true"/>
            </div>

            <div class="col-md-4 col-sm-4">
              <fg-input v-model="diadoc_info.title" type="text" :label="translate('diadoc_document.info.title')"
                        :placeholder="translate('diadoc_document.info.title')" :readonly="true"/>
            </div>

            <div class="col-md-3 col-sm-3">
              <fg-input v-model="diadoc_info.docflow_status_text" type="text" :label="translate('diadoc_document.info.docflow_status_text')"
                        :placeholder="translate('diadoc_document.info.docflow_status_text')" :readonly="true"/>
            </div>

            <div class="col-md-3 col-sm-3">
              <fg-input v-model="diadoc_info.type_named_id" type="text" :label="translate('diadoc_document.info.type_named_id')"
                        :placeholder="translate('diadoc_document.info.type_named_id')" :readonly="true"/>
            </div>
          </div>

          <div class="line row">
            <div class="col-md-6 col-sm-6">
              <fg-input v-model="diadoc_info.file_name" type="text" :label="translate('diadoc_document.info.file_name')"
                        :placeholder="translate('diadoc_document.info.file_name')" :readonly="true"/>
            </div>
          </div>

          <div class="line row">
            <div class="col-md-3 col-sm-3">
              <fg-input v-model="diadoc_message_timestamp" type="text" :label="translate('diadoc_document.info.diadoc_message_timestamp')"
                        :placeholder="translate('diadoc_document.info.diadoc_message_timestamp')" :readonly="true"/>
            </div>

            <div class="col-md-3 col-sm-3">
              <fg-input v-model="diadoc_document_timestamp" type="text" :label="translate('diadoc_document.info.diadoc_document_timestamp')"
                        :placeholder="translate('diadoc_document.info.diadoc_document_timestamp')" :readonly="true"/>
            </div>

            <div class="col-md-3 col-sm-3">
              <fg-input v-model="created_at" type="text" :label="translate('diadoc_document.info.created_at')"
                        :placeholder="translate('diadoc_document.info.created_at')" :readonly="true"/>
            </div>

            <div class="col-md-3 col-sm-3">
              <fg-input v-model="updated_at" type="text" :label="translate('diadoc_document.info.updated_at')"
                        :placeholder="translate('diadoc_document.info.updated_at')" :readonly="true"/>
            </div>
          </div>
        </div>

        <div class="line text-right buttons">
          <span
              v-if="diadoc_info.file_url"
              class="btn btn-warning btn-fill btn-wd"
              @click.prevent="download_file(diadoc_info.file_url, diadoc_info.file_name)"
          >
            {{ translate('diadoc_document.info.download_file') }}
            {{ diadoc_info.file_size_bytes ? `(${Math.round(Number(diadoc_info.file_size_bytes) / 1024)} кб)` : "" }}
          </span>
        </div>
      </div>

      <div
          v-if="diadoc_info.file_url && is_docx"
          ref="docxPreview"
          class="docx-preview"
      ></div>

      <iframe
          v-if="diadoc_info.file_url && is_pdf && pdf_src"
          :src="pdf_src"
          class="pdf-preview"
          frameborder="0"
      ></iframe>
    </div>

    <div class="diadoc_info__right" v-if="$store.getters.getPermissions?.permissionGod === true">
      <Summary type="diadoc_document" :info="diadoc_info" :view_history="false" />
    </div>
  </div>

  <div class="loading" v-else>
    <div class="spinner">
      <scale-loader />
    </div>
  </div>

</template>
<script>
import WrapDatePicker from "components/UIComponents/WrapDatePicker/WrapDatePicker.vue";
import Summary from "components/UIComponents/Summary/Summary.vue";
import GlobalRequest from "@/API/global_request";

import * as docxPreview from 'docx-preview/dist/docx-preview.js';

const fields_to_check = ["date_act"];

const Request = {...GlobalRequest}

export default {
  name: 'DiadocDocumentInfo',
  components: {
    WrapDatePicker,
    Summary
  },

  props: {
    diadoc: {
      type: Object,
      required: true
    },
  },

  data() {
    return {
      diadoc_info: {},
      filter_type: "",
      filter_asc: "asc",
      loading: false,
      pdf_src: "",
    }
  },

  beforeDestroy() {
    this.clear_document();
  },

  deactivated() {
    setTimeout(() => {
      this.diadoc_info = {}
    }, 500);
  },

  computed: {
    file_extension() {
      const fileName = String(this.diadoc_info.file_name || '');

      return fileName
          .split('?')[0]
          .split('.')
          .pop()
          .toLowerCase();
    },

    is_docx() {
      return this.file_extension === 'docx';
    },

    is_pdf() {
      return this.file_extension === 'pdf';
    },
    diadoc_message_timestamp(){
      return this.get_date(this.diadoc_info.diadoc_message_timestamp)
    },
    diadoc_document_timestamp(){
      return this.get_date(this.diadoc_info.diadoc_document_timestamp)
    },
    created_at(){
      return this.get_date(this.diadoc_info.created_at)
    },
    updated_at(){
      return this.get_date(this.diadoc_info.updated_at)
    },
    has_changes() {
      let diadoc_info = fields_to_check.reduce((obj, key) => {
        obj[key] = this.diadoc_info[key];
        return obj;
      }, {});

      let diadoc = fields_to_check.reduce((obj, key) => {
        obj[key] = this.diadoc[key];
        return obj;
      }, {});

      return JSON.stringify(diadoc_info) !== JSON.stringify(diadoc);
    }
  },

  watch: {
    diadoc: {
      handler(new_val) {
        this.diadoc_info = JSON.parse(JSON.stringify(new_val));

        this.$nextTick(() => {
          this.render_document();
        });
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    async render_document() {
      this.clear_document();

      if (!this.diadoc_info.file_url) {
        return;
      }

      if (this.is_docx) {
        await this.show_docx(this.diadoc_info.file_url);
      }

      if (this.is_pdf) {
        await this.show_pdf(this.diadoc_info.file_url);
      }
    },

    async get_file_blob(file_url) {
      Request.baseURL =
          process.env.VUE_APP_BASE_URL || window.location.origin;

      const response = await Request.get(
          file_url.replace(/^\//, ''),
          null,
          {
            responseType: 'blob'
          }
      );

      console.log(response.data)

      return response.data;
    },

    async show_docx(file_url) {
      const preview = this.$refs.docxPreview;

      if (!preview) {
        return;
      }

      const blob = await this.get_file_blob(file_url);

      if (file_url !== this.diadoc_info.file_url) {
        return;
      }

      preview.innerHTML = '';

      await docxPreview.renderAsync(
          blob,
          preview,
          null,
          {
            inWrapper: true,
            breakPages: true,
          }
      );
    },

    async show_pdf(file_url) {
      const blob = await this.get_file_blob(file_url);

      if (file_url !== this.diadoc_info.file_url) {
        return;
      }

      if (this.pdf_src) {
        URL.revokeObjectURL(this.pdf_src);
      }

      this.pdf_src = URL.createObjectURL(blob);
    },
    clear_document() {
      if (this.$refs.docxPreview) {
        this.$refs.docxPreview.innerHTML = '';
      }

      if (this.pdf_src) {
        URL.revokeObjectURL(this.pdf_src);
        this.pdf_src = '';
      }
    },
    download_file(file_url, file_name){
      const baseUrl = process.env.VUE_APP_BASE_URL || window.location.origin;
      const url = new URL(file_url, new URL(baseUrl, window.location.origin)).href;
      const link = document.createElement('a');

      link.href = url;
      link.download = file_name;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}

</script>

<style lang='scss' scoped>
.diadoc_info {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  overflow: auto;

  @media (max-width: 991px) {
    flex-direction: column;
  }

  &__left {
    width: 70%;
    height: 100%;
    padding-right: 10px;
    @media (max-width: 991px) {
      width: 100%;
      height: auto;
    }

    .form_select{
      .form-control {
        width: 100%;
      }
    }

    .buttons {
      margin-top: 10px;
      .btn{
        margin-right: 10px;
        &:last-child{
          margin-right: 0;
        }
      }
    }
  }

  &__right {
    width: 30%;
    height: 100%;
    @media (max-width: 991px) {
      width: 100%;
      height: auto;
    }
  }

  .docx-preview {
    margin-top: 10px;
    width: 100%;
    max-height: 80vh;
    overflow: auto;
    background: #e5e5e5;
  }

  .pdf-preview {
    margin-top: 10px;
    width: 100%;
    height: 80vh;
    border: none;
  }
}
</style>
